/**
 * FounderBand (iter1070) — елегантна лента със създателя на платформата.
 * Умерена по тон: едно име, една роля, едно изречение и препратка към
 * пълния научен профил.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { DR_INKOV_PHOTO } from "@/data/consultants";

const TX = {
  bg: {
    eyebrow: "Създателят на платформата",
    name: "Д-р Иван Инков",
    role: "Гръден хирург и онкомамолог · Основател и научен директор",
    line: "Идеята за мрежата от дигитални близнаци възниква в лекарския кабинет. Тя свързва процеси, които д-р Инков проследява при пациентите си: как обмяната на веществата и хормоните влияят върху състоянието на тъканите.",
    credentials: "Цюрих · Улм · Монпелие · Милано · Лондон · Европейско училище по онкология",
    cta: "Вижте научния профил",
  },
  en: {
    eyebrow: "The founder of the platform",
    name: "Dr Ivan Inkov",
    role: "Breast surgeon and oncomammologist · Founder and Scientific Director",
    line: "The idea for the digital twin network arose in a consulting room. It links processes Dr Inkov follows in his own patients: how metabolism and hormones affect the state of the tissue.",
    credentials: "Zurich · Ulm · Montpellier · Milan · London · European School of Oncology",
    cta: "See the scientific profile",
  },
  es: {
    eyebrow: "El creador de la plataforma",
    name: "Dr. Ivan Inkov",
    role: "Cirujano de mama y oncomamólogo · Fundador y Director Científico",
    line: "La idea de la red de gemelos digitales surge en la consulta médica. Une procesos que el Dr. Inkov sigue en sus propios pacientes: cómo el metabolismo y las hormonas influyen en el estado del tejido.",
    credentials: "Zúrich · Ulm · Montpellier · Milán · Londres · Escuela Europea de Oncología",
    cta: "Ver el perfil científico",
  },
};


export default function FounderBand({ isDark, language = "bg" }) {
  const t = TX[language] || TX.bg;
  return (
    <section data-testid="landing-founder-band"
      className={`py-16 sm:py-20 ${isDark ? "bg-[#0F172A]" : "bg-[#F1F5F9]"}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className={`rounded-2xl border p-6 sm:p-8 ${
          isDark ? "border-slate-800 bg-[#090D16]" : "border-slate-200 bg-white shadow-sm"}`}>
          <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-start">
            <img src={DR_INKOV_PHOTO} alt={t.name} loading="lazy"
              data-testid="landing-founder-photo"
              className="w-24 h-24 sm:w-28 sm:h-28 rounded-2xl object-cover shrink-0 ring-1 ring-slate-200 dark:ring-slate-800" />
            <div className="min-w-0">
              <div className={`text-xs font-bold uppercase tracking-[0.2em] mb-2 ${
                isDark ? "text-teal-300" : "text-teal-700"}`}>{t.eyebrow}</div>
              <h2 className={`text-2xl sm:text-3xl font-semibold tracking-tight ${
                isDark ? "text-white" : "text-slate-900"}`}
                data-testid="landing-founder-name">{t.name}</h2>
              <p className={`text-base sm:text-sm font-medium mt-1 ${
                isDark ? "text-slate-300" : "text-slate-700"}`}>{t.role}</p>
              <div className="flex gap-2.5 mt-4">
                <Quote className={`w-4 h-4 mt-0.5 shrink-0 ${
                  isDark ? "text-slate-600" : "text-slate-300"}`} />
                <p className={`text-sm leading-relaxed ${
                  isDark ? "text-slate-400" : "text-slate-600"}`}>{t.line}</p>
              </div>
              <p className={`text-xs mt-4 ${isDark ? "text-slate-500" : "text-slate-500"}`}>
                {t.credentials}
              </p>
              <Link to="/consultants/inkov" data-testid="landing-founder-cta"
                className={`inline-flex items-center gap-1.5 text-sm font-semibold mt-5 ${
                  isDark ? "text-teal-300 hover:text-teal-200" : "text-teal-700 hover:text-teal-900"}`}>
                {t.cta} <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
